<template>
    <section class="section section-shaped my-0 overflow-hidden">
        <div class="shape shape-style-3 bg-gradient-default shape-skew">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container shape-container py-0 pb-5">
            <div class="row row-grid justify-content-between align-items-center">
                <div class="col-lg-6">
                    <h3 class="text-pink mb-4">Comme une envie de changer d'air !
                    </h3>
                    <p class="text-white">Avec ce premier confinement en
                        mars 2020, nous avons collectivement
                        pris conscience de ce qui
                        comptait, de l’importance de nos
                        commerces de proximité. Ces lieux
                        de rencontre, de vie, de sociabilisation.
                        Il en va de même pour nous, nous nous sommes donc recentrés
                        sur ce que nous souhaitions apporter en tant qu'individus.</p>
                    <p class="text-white">Tout en mêlant nos deux projets
                        d’épicerie et de restauration mais
                        surtout notre amour pour le terroir et
                        ces valeurs, nous discutons, nous prenons
                        l’apéro, nous rediscutons, nous
                        reprenons l’apéro.... Et là...</p>
                    <p class="lead font-weight-bold text-pink">Azterrren est né !</p>

                </div>
                <div class="col-lg-5 mb-lg-auto d-none d-md-block">
                    <div class="transform-perspective-right">
                        <icon-courses2
                            height="400"
                            width="400"
                            class="iconBase-pink "
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import IconCourses2 from '../components/icons/courses2.vue'
export default {
  name: 'IconBase',
  components: {
    IconCourses2,
  },
}
</script>